import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights, minWidth, Text } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';
import Card from 'icons/credit-card.svg';
import Lock from 'icons/lock-outline.svg';
import Mail from 'icons/mail.svg';

import messages from './messages';

// Row
const Wrapper = styled(GridWrapper)`
	padding-top: 3rem;
	padding-bottom: 3.5rem;
`;

const FullWidth = styled(Text).attrs({
	el: 'h2',
})`
	color: ${palette('buttonBlue')};
	text-align: center;
	margin-bottom: 1.5rem;

	${minWidth('tablet')} {
		grid-column: 1 / -1;
		margin-bottom: 2rem;
	}
`;

const Section = styled.div`
	margin-bottom: 2rem;
	text-align: center;

	&:last-of-type {
		margin-bottom: 0;
	}

	${minWidth('tablet')} {
		margin-bottom: 0;
	}
`;

const IconCircle = styled.div`
	width: 64px;
	height: 64px;
	margin: 0 auto;

	svg {
		height: 64px;
		width: 64px;

		path {
			fill: ${palette('buttonBlue')};
		}
	}
`;

const SectionTitle = styled.h4`
	${fontSize(FontSizes.lg)};
	${fontWeight(FontWeights.Medium)};
	line-height: 33px;
	width: 100%;
	text-align: center;
	margin: 16px 0 8px;
	color: ${palette('blackAlpha80')};
`;

const SectionDescription = styled.p`
	${fontSize(FontSizes.base)};
	${fontWeight(FontWeights.Regular)};
	line-height: 27px;
	width: 100%;
	text-align: center;
	max-width: 240px;
	margin: 0 auto;
	color: ${palette('blackAlpha80')};
`;

const HowItWorks = () => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper columns={3}>
			<FullWidth>{formatMessage(messages.howItWorksTitle)}</FullWidth>
			<Section>
				<IconCircle>
					<Card />
				</IconCircle>
				<SectionTitle>{formatMessage(messages.howItWorksPurchaseStepTitle)}</SectionTitle>
				<SectionDescription>{formatMessage(messages.howItWorksPurchaseStepDescription)}</SectionDescription>
			</Section>
			<Section>
				<IconCircle>
					<Mail />
				</IconCircle>
				<SectionTitle>{formatMessage(messages.howItWorksSendStepTitle)}</SectionTitle>
				<SectionDescription>{formatMessage(messages.howItWorksSendStepDescription)}</SectionDescription>
			</Section>
			<Section>
				<IconCircle>
					<Lock />
				</IconCircle>
				<SectionTitle>{formatMessage(messages.howItWorksRedeemStepTitle)}</SectionTitle>
				<SectionDescription>{formatMessage(messages.howItWorksRedeemStepDescription)}</SectionDescription>
			</Section>
		</Wrapper>
	);
};

export default HowItWorks;
